import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { DatePicker, Flex, Input, Select, Typography } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { MaskedInput } from 'antd-mask-input';
import { paymentsAction } from 'src/store/Slices/Administrator/PaymentsSlice';
import { getUsers } from 'src/store/Slices/DropDownSlice';
import { getUserInfo } from 'src/store/Slices/ClientsSlice';

const AddEditPaymentModal = ({ visible, setVisible, clientInfo, setPage, setPageSize }) => {

    const dispatch = useDispatch()

    const [userId, setUserId] = useState()
    const [name, setName] = useState()
    const [phone, setPhone] = useState()
    const [datePayment, setDatePayment] = useState()
    const [sum, setSum] = useState()
    const [cardType, setCardType] = useState()
    const [cardNumber, setCardNumber] = useState()

    const users = useSelector(state => state.DropDownSlice.users)
    const usersLoading = useSelector(state => state.DropDownSlice.usersLoading)
    const userInfo = useSelector(state => state.ClientsSlice.userInfo)

    useEffect(() => {
        setName()
        setPhone()
        setDatePayment()
        setSum()
        setCardType()
        setCardNumber()
    }, [visible.flag])


    useEffect(() => {
        if (visible.flag === 'edit') {
            setName(clientInfo?.clientFio)
            setPhone(clientInfo?.phone)
            // setDatePayment(clientInfo?.paymentDate)
            setSum(clientInfo?.price)
            setCardType(clientInfo?.cardType)
            setCardNumber(clientInfo?.lastFour)
        }
    }, [visible, clientInfo])

    const onClickSubmit = () => {
        dispatch(paymentsAction({
            flag: visible.flag === 'add' ? 'put' : 'post', value: {
                userId: userId,
                id: visible.flag !== 'add' ? clientInfo.id : undefined,
                clientFio: name,
                clientPhone: phone,
                cardType: cardType,
                lastFour: cardNumber,
                sum: Number(sum),
                payDate: datePayment,
            }
        })).then(() => {
            dispatch(paymentsAction({ flag: 'get' })).then(() => {
                setVisible({ open: false, flag: '' })
                setPage(1)
                setPageSize(20)
            })
        })
    }

    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить оплату' : 'Редактировать оплату'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>ФИО</Typography.Title>
                            <Select
                                filterSort={false}
                                filterOption={false}
                                loading={usersLoading}
                                showSearch
                                onSearch={(value) => { dispatch(getUsers({ search: value })) }}
                                onClick={() => { dispatch(getUsers()) }}
                                placeholder='Выбрать'
                                style={{ width: '100%' }}
                                value={name}
                                options={users?.data?.value}
                                onChange={(e, b) => {
                                    setUserId(e);
                                    setName(b?.label)
                                }}
                                onSelect={(id) => {
                                    dispatch(getUserInfo({ id: id })).then((res) => {
                                        if (res?.payload?.data?.isSuccess) {
                                            setPhone(res?.payload?.data?.value?.phoneNumber)
                                        }
                                    })
                                }}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Номер телефона</Typography.Title>
                            <Input
                                disabled
                                value={phone}
                                onChange={(e) => { setPhone(e.target.value) }}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Дата платежа</Typography.Title>
                            <DatePicker
                                style={{ width: '100%' }}
                                value={datePayment}
                                onChange={e => setDatePayment(e)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Сумма</Typography.Title>
                            <Input
                                value={sum}
                                onChange={e => setSum(e.currentTarget.value)}
                                type='number'
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Тип карты</Typography.Title>
                            <Input
                                value={cardType}
                                onChange={e => setCardType(e.currentTarget.value)}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Номер карты</Typography.Title>
                            <Input
                                value={cardNumber}
                                onChange={e => setCardNumber(e.currentTarget.value)}
                                type='number'
                                maxLength={4}
                            />
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditPaymentModal